import React from 'react'
import PropTypes from 'prop-types'
import ReactTooltip from 'react-tooltip'

import Icon from '../../../Icons'

const renderTooltip = (tooltips) => {
  return (
    <React.Fragment>
      {tooltips.map((tooltip) => (
        <div key={tooltip}>{tooltip}</div>
      ))}
    </React.Fragment>
  )
}

const Tooltip = ({ tooltips, name }) => {
  return (
    <span data-tip data-for={`${name}-triggerTip`}>
      <Icon
        icon="exclamationPoint"
        styles={{
          width: '20px',
          height: '20px',
        }}
        svgProps={{ strokeWidth: '2px', fill: 'black' }}
      />
      <ReactTooltip
        className="tooltip"
        id={`${name}-triggerTip`}
        multiline
        place="right"
        effect="solid"
      >
        {renderTooltip(tooltips)}
      </ReactTooltip>
    </span>
  )
}

Tooltip.propTypes = {
  tooltips: PropTypes.array,
  name: PropTypes.string,
}

export default Tooltip
